import React, { useState } from 'react';
import SubscriptionBlur from './SubscriptionBlur';
import './ImageCarousel.css';

const ImageCarousel = ({ images, isLocked = false }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  // Filtrer les images non nulles
  const validImages = images.filter(img => img);
  
  // Si aucune image valide, afficher un placeholder
  if (validImages.length === 0) {
    return (
      <div className="carousel-container">
        <img 
          src="https://via.placeholder.com/400x300?text=Image+non+disponible" 
          alt="Placeholder" 
          className="carousel-image"
        />
      </div>
    );
  }
  
  // Si une seule image, l'afficher sans contrôles
  if (validImages.length === 1) {
    return (
      <SubscriptionBlur isLocked={isLocked}>
        <div className="carousel-container">
          <div className="carousel-inner">
            <img
              src={validImages[0]}
              alt="Image"
              className="carousel-image"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://via.placeholder.com/400x300?text=Image+non+disponible";
              }}
            />
          </div>
        </div>
      </SubscriptionBlur>
    );
  }
  
  // Passer à l'image précédente
  const goToPrevious = () => {
    const isFirstImage = currentIndex === 0;
    const newIndex = isFirstImage ? validImages.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };
  
  // Passer à l'image suivante
  const goToNext = () => {
    const isLastImage = currentIndex === validImages.length - 1;
    const newIndex = isLastImage ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };
  
  // Aller à une image spécifique
  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };
  
  return (
    <SubscriptionBlur isLocked={isLocked}>
      <div className="carousel-container">
        <div className="carousel-inner">
          <img 
            src={validImages[currentIndex]} 
            alt={`Image ${currentIndex + 1}`} 
            className="carousel-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://via.placeholder.com/400x300?text=Image+non+disponible";
            }}
          />
          
          <button className="carousel-arrow left-arrow" onClick={goToPrevious}>
            &#10094;
          </button>
          <button className="carousel-arrow right-arrow" onClick={goToNext}>
            &#10095;
          </button>
        </div>
        
        <div className="carousel-dots">
          {validImages.map((_, slideIndex) => (
            <div 
              key={slideIndex} 
              className={`carousel-dot ${slideIndex === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(slideIndex)}
            >
              •
            </div>
          ))}
        </div>
      </div>
    </SubscriptionBlur>
  );
};

export default ImageCarousel;
